export default __webpack_public_path__ + "static/media/fluent_luggage-28-filled.3019afc1.svg";